import Home from './home'
import ExchangePage from './exchangepage'
import ExchangeRecord from './exchangeRecord'
import RecycleSelect from './recycleSelect'
import RecycleRecord from './recycleRecord'
export default {
  Home,
  ExchangePage,
  ExchangeRecord,
  RecycleSelect,
  RecycleRecord
}
